import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body border-top p-9" }
const _hoisted_2 = { class: "row mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6" }, " Tên kho: ", -1)
const _hoisted_4 = { class: "col-lg-8 fv-row" }
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { role: "alert" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6" }, " Mã kho: ", -1)
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { role: "alert" }
const _hoisted_14 = { class: "row mb-6 mt-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fw-bold fs-6" }, " Ghi chú kho: ", -1)
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6" }, " Địa chỉ ", -1)
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { role: "alert" }
const _hoisted_23 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_TaiKhoanSelection = _resolveComponent("TaiKhoanSelection")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createBlock(_component_PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(" Tạo mới ")
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.BACK,
        "color-type": _ctx.ButtonTypeColors.PRIMARY,
        onClick: _ctx.goBack
      }, null, 8, ["button-type", "color-type", "onClick"])
    ]),
    "page-row-content": _withCtx(() => [
      _createElementVNode("form", {
        class: "form",
        onKeypress: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "name",
                ref: "firstInput",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Tên kho",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.name]
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.nameErrorMess), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "code",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Mã kho",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.code) = $event))
              }, null, 512), [
                [_vModelText, _ctx.code]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.codeErrorMess), 1)
                ])
              ])
            ])
          ]),
          _createVNode(_component_TaiKhoanSelection, {
            labelCols: 2,
            inputsCols: 4,
            label: "Tài khoản",
            onOnSelect: _ctx.onSelectTaiKhoan
          }, null, 8, ["onOnSelect"]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "note",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Ghi chú",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.note) = $event))
              }, null, 512), [
                [_vModelText, _ctx.note]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "address",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Địa chỉ",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address) = $event))
              }, null, 512), [
                [_vModelText, _ctx.address]
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.addressErrorMess), 1)
                ])
              ])
            ])
          ])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.SAVE,
          "color-type": _ctx.ButtonTypeColors.PRIMARY,
          onClick: _ctx.onSubmit
        }, null, 8, ["button-type", "color-type", "onClick"])
      ])
    ]),
    _: 1
  }))
}